export default function BigTitle(props) {
    return <div id="title" >STEVEN ZHANG</div>

}